<template>
  <div>
    <div class="game_hot_item" @click="godetail">
      <div v-if="rank_num" class="ranknum">
        <img v-if="rank_num == 1" src="@/assets/image/home/11.png" />
        <img v-if="rank_num == 2" src="@/assets/image/home/22.png" />
        <img v-if="rank_num == 3" src="@/assets/image/home/33.png" />
        <span
          :style="{ color: rank_num > 3 ? '#000' : '#fff', fontWeight: rank_num > 3 ? '700' : 'normal', fontSize: rank_num > 3 ? '.8rem' : '.6rem' }">{{
            rank_num }}</span>
      </div>
      <s-image borderRadius=".5rem" class="icon" :src="item.icon || item.game_icon" alt="" mode="scaleToFill"/>
      <div class="game_right">
        <div class="hot_center">
          <div class="sizeomit h4" v-html="item.name || item.game_name"></div>
          <div class="tag">
            <div class="tag_item" v-for="it, j in item.labels" :key="j">
              <span>{{ it }}</span> <span v-if="it != item.labels[item.labels.length - 1]" style="margin: 0 .25rem;"> ·
              </span>
            </div>
          </div>
          <div class="ftitle sizeomit">{{ item.intro }}</div>
        </div>
        <div class="down" v-if="btnnone">
          <game-start :resource="resource" :extend_id="extend_id" :item="item" v-if="isbtn" />
          <follow-button :item="item" v-else></follow-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { gamelogup } from '../../api/common'
export default {
  name: 'UniMailiangGameItem',

  props: {
    follow: {
      type: Boolean,
      default: true,
    },
    item: {
      type: Object,
      default: {}
    },
    rank_num: {
      type: Number,
      default: 0,
    },
    isbtn: {
      type: Boolean,
      default: true,
    },
    btnnone: {
      type: Boolean,
      default: true,
    },
    isgo: {
      type: Boolean,
      default: true,
    },
    resource: { // 上报资源位 1 推荐 2 排行 3 分类
      type: String,
      default: ''
    },
    extend_id: {
      default: ''
    },
    isRoleSearch: {
      type: Boolean,
      default: false
    },
    pagetype: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      percent: 0,
    };
  },

  methods: {
    godetail() {
      if (!this.isgo) return
      // if (this.resource) {
      //   gamelogup({
      //     game_id: this.item.game_id,
      //     type: 4,
      //     resource: this.resource,
      //     extend_id: this.extend_id
      //   })
      // }
      if (!this.isRoleSearch) {

        this.$router.push({
          path: '/pages/index/gamedetail/gamedetail',
          query: { id: this.item.game_id }
        })
      } else {
        if(this.pagetype){
          this.$emit('changeGameTab', 0, this.item.game_id,  {
            ...this.item,
            name: this.item.name.replace(/<[^>]+>/g, '')
          })
        }else{
          this.$router.push({
            path: '/pages/index/RoleList/RoleList',
            query: {
              game_id: this.item.game_id,
              issearch: true
            }
          })
        }
      }

    },
  },
};
</script>

<style lang="scss" scoped>
.game_hot_item {
  position: relative;
  // width: 100%;
  height: 4.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 .5rem;
  background-color: #fff;
  border-radius: .25rem;

  .ranknum {
    text-align: center;
    color: #000;
    margin-right: .45rem;
    white-space: nowrap;
    font-weight: 700;

    img {
      position: absolute;
      width: .7rem;
      left: .33rem;
      top: 50%;
      transform: translateY(-40%);
    }

    span {
      position: relative;
      z-index: 1;
    }
  }

  .icon {
    width: 3.25rem;
    height: 3.25rem;
    border-radius: .5rem;
    display: block;
    overflow: hidden;
  }

  .game_right {
    display: flex;
    overflow: hidden;
    justify-content: space-between;
    align-items: center;
    border-bottom: .05rem solid #f8f8f8;
    height: 100%;
    flex: 1;
  }

  .hot_center {
    flex: 1;
    width: 50%;
    overflow: hidden;
    margin: 0 .4rem;
    height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    padding: .1rem 0;

    .ftitle {
      font-size: .6rem;
      color: #cacaca;
    }

    .h4 {
      font-weight: 700;
      color: #000;
      font-size: .7rem;
    }

    .tag {
      width: 100%;
      display: flex;
      flex-wrap: nowrap;
      overflow-x: auto;
      color: #8e8e8e;

      &::-webkit-scrollbar {
        display: none;
      }

      .tag_item {
        font-size: .6rem;
        white-space: nowrap;
      }
    }
  }

  .down {
    button {
      font-size: .7rem;
      padding: 0;
      color: #ffdb89;
      line-height: 1.5rem;
      width: 3rem;
      height: 1.5rem;
      background: linear-gradient(87deg, #1d1d1d 0%, #5b4e3f 100%);
      border-radius: .75rem;
    }

    .u_line {
      width: 3rem !important;
      height: 1.5rem !important;
      padding: 0 !important;
    }
  }
}
</style>